export const defaultDescription = "";

export const defaultKeywords = "";